<script lang="ts">

    import {onMount} from "svelte";
    import { storeNextPlenaryDate } from "../scripts/plenary";
    import {getNextPlenaryDate} from "../scripts/apiPlenaries";
    import Line from "./Line.svelte";
    import { storeLanguage, lang_fr } from "../scripts/store";

    let t = 0;
    let deadline = 0;
    let days = 0;
    let hours = 0;
    let hoursString = "00";
    let minutes = 0;
    let minutesString = "00";
    let seconds = 0;
    let secondsString = "00";

    let displayCountdown = false;

    onMount(async () => {
        if ($storeNextPlenaryDate == undefined || $storeNextPlenaryDate == "") {
            getNextPlenaryDate();
        }
	});

    storeNextPlenaryDate.subscribe((data: string) => {
        if (data != undefined && data != "") {
            const datePlenaryArray = data.split("-");
            deadline = new Date(parseInt(datePlenaryArray[0]), parseInt(datePlenaryArray[1])-1, parseInt(datePlenaryArray[2]), 8).getTime();
            let t = deadline - new Date().getTime();
            displayCountdown = true;
        }
    })

    let x = setInterval(function() {
                t = deadline - new Date().getTime();
                days = Math.floor(t / (1000 * 60 * 60 * 24));

                hours = Math.floor((t%(1000 * 60 * 60 * 24))/(1000 * 60 * 60));
                if (hours < 10) {
                    hoursString = "0"+hours.toString();
                } else {
                    hoursString = hours.toString();
                }

                minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
                if (minutes < 10) {
                    minutesString = "0"+minutes.toString();
                } else {
                    minutesString = minutes.toString();
                }

                seconds = Math.floor((t % (1000 * 60)) / 1000);
                if (seconds < 10) {
                    secondsString = "0"+seconds.toString();
                } else {
                    secondsString = seconds.toString();
                }
                }, 1000);

</script>
    
<style lang="scss">

    .homepleniere {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        background-color: $color_white;
        background: linear-gradient(to right, $color_white, $color_grey, $color_white);
        cursor: default;
        padding: 60px 0 0 0;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__subtitle {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            color: $color_text;
            text-align: center;
        }
        &__countdown {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: 50px 0 0 0;
            display: none;
            &__display {
                display: block;
            }
            &__line {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: flex-start;
            }
            &__digit {
                text-align: center;
                font-size: 35px;
                font-weight: 600;
                color: $color_primary;
                width: 75px;
            }
            &__semicolon {
                text-align: center;
                font-size: 35px;
                font-weight: 600;
                color: $color_primary;
                width: 15px;
            }
            &__word {
                text-align: center;
                color: $color_orange;
                width: 75px;
            }
        }
        &__nocountdown {
            margin: 0 0 30px 0;
            display: none;
            &__display {
                display: block;
            }
        }
    }

    @include large {
        .homepleniere {
            &__countdown {
                &__digit {
                    font-size: 70px;
                    width: 150px;
                }
                &__semicolon {
                    font-size: 70px;
                    width: 30px;
                }
                &__word {
                    width: 150px;
                }
            }
        }
    }

</style>

<div class="homepleniere">
    <div class="bloc homepleniere__bloc">
        <div class="homepleniere__subtitle font__h2">
            {#if ($storeLanguage == $lang_fr)}
            Prochaine session plénière
            {:else}
            Next plenary session
            {/if}
        </div>
        <Line />
        <div class="homepleniere__countdown" class:homepleniere__countdown__display={displayCountdown}>
            <div class="homepleniere__countdown__line">
                <div class="homepleniere__countdown__digit">{days}</div>
                <div class="homepleniere__countdown__semicolon">:</div>
                <div class="homepleniere__countdown__digit">{hoursString}</div>
                <div class="homepleniere__countdown__semicolon">:</div>
                <div class="homepleniere__countdown__digit">{minutesString}</div>
                <div class="homepleniere__countdown__semicolon">:</div>
                <div class="homepleniere__countdown__digit">{secondsString}</div>
            </div>
            <div class="homepleniere__countdown__line">
                <div class="homepleniere__countdown__word font__h4">
                    {#if ($storeLanguage == $lang_fr)}
                    JOURS
                    {:else}
                    DAYS
                    {/if}
                </div>
                <div class="homepleniere__countdown__semicolon">&nbsp;</div>
                <div class="homepleniere__countdown__word font__h4">
                    {#if ($storeLanguage == $lang_fr)}
                    HEURES
                    {:else}
                    HOURS
                    {/if}
                </div>
                <div class="homepleniere__countdown__semicolon">&nbsp;</div>
                <div class="homepleniere__countdown__word font__h4">MINUTES</div>
                <div class="homepleniere__countdown__semicolon">&nbsp;</div>
                <div class="homepleniere__countdown__word font__h4">
                    {#if ($storeLanguage == $lang_fr)}
                    SECONDES
                    {:else}
                    SECONDS
                    {/if}               
                </div>
            </div>
        </div>
        <div class="homepleniere__nocountdown" class:homepleniere__nocountdown__display={!displayCountdown}>
            {#if ($storeLanguage == $lang_fr)}
            Date en cours de planification
            {:else}
            Date being planned
            {/if}               
        </div>
    </div>
</div>
